import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NoOpDataSourceValueInfoSource } from "abweb/service/dsinfo/NoOpDataSourceValueInfoSource";
export class DataSourceValueInfoService {
  constructor() {
    _defineProperty(this, "_infoSource", new NoOpDataSourceValueInfoSource());
  }
  getIcon(value) {
    return this._infoSource.getIcon(value);
  }
  getClassDisplayName(value) {
    return this._infoSource.getClassDisplayName(value);
  }
  getFeatureIdentifier(value, feature) {
    return this._infoSource.getFeatureIndicator(value, feature);
  }
  setInfoSource(dataSourceValueInfoSource) {
    this._infoSource = dataSourceValueInfoSource;
  }
  refresh() {
    this._infoSource.refresh();
  }
}
//# sourceMappingURL=DataSourceValueInfoService.js.map
